import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {
  provideRouter,
  Router
} from '@angular/router';
import { routes } from './app/app.routes';
import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { MCFormlyValidationConfig, MCConfigService, MCEnvironmentsService, MCHttpWrapperService, MCTranslationStateService } from '@maslul/common-services';
import { environment } from './environments/environment';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
//import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { EnvironmentsService } from './app/services/shared/environments.service';
import { ConfigService } from './app/services/shared/config.service';
import { FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng'
import { customFormlyConfig } from './assets/config/formly.config';
import { CustomTranslateLoader } from './assets/i18n/CustomTranslateLoader';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});
export function ConfigLoader(configService: MCConfigService) {
  return () => configService.load(environment.configFile);
}

export function CustomLoaderFactory(
  http: HttpClient,
  translationStateService: MCTranslationStateService) {

  return new CustomTranslateLoader(http, translationStateService);

}


function initializeAppAndRedirect(
  router: Router,
  translationStateService: MCTranslationStateService
): () => Promise<any> {
  return () => {
    return new Promise<void>((resolve) => {
      translationStateService.setTranslationsLoaded(false);
      router.navigateByUrl('/')
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.error("נכשלה טעינת התרגומים:", error);
        });
    });

  }
}

bootstrapApplication(AppComponent, {
  providers: [
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          cssLayer: {
            name: 'primeng',
          }
        },

      }
    }),
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes),

    {
      provide: MCEnvironmentsService,
      useClass: EnvironmentsService
    },
    {
      provide: MCConfigService,
      useClass: ConfigService
    },
    provideAppInitializer(() => {
      const initializerFn = (ConfigLoader)(inject(MCConfigService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = (initializeAppAndRedirect)(inject(Router), inject(MCTranslationStateService));
      return initializerFn();
    }),

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: CustomLoaderFactory,
          deps: [HttpClient, MCTranslationStateService]
        }
      }),
      FormlyModule.forRoot(customFormlyConfig),
      FormlyPrimeNGModule
    ),
    {
      provide: FORMLY_CONFIG,
      multi: true, useFactory: MCFormlyValidationConfig, deps: [TranslateService]
    }


  ]

}).catch(err => console.error(err));